import { forwardRef, createElement } from 'react';

function IconProfile(props, svgRef) {
  return createElement("svg", Object.assign({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a9.97 9.97 0 003.047 7.187A9.967 9.967 0 0012 22a9.967 9.967 0 006.953-2.813A9.97 9.97 0 0022 12zM5.704 16.936A7.986 7.986 0 0012 20a7.986 7.986 0 006.296-3.064A7 7 0 0012 13a7 7 0 00-6.296 3.936zM12 12a3.5 3.5 0 100-7 3.5 3.5 0 000 7z",
    fill: "currentColor"
  }));
}

var Profile = /*#__PURE__*/forwardRef(IconProfile);

export default Profile;
//# sourceMappingURL=Profile.js.map
